import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { AdDialogConfig } from '../ad-dialog-config';
import { CONFIG_DATA } from '../common/ad-dialog-config-inject-key';

@Component({
  selector: 'a-confirm',
  templateUrl: './a-confirm.component.html',
  styleUrls: ['./a-confirm.component.scss']
})
export class AConfirmComponent implements OnInit, OnDestroy {

  constructor(@Inject(CONFIG_DATA) private context: any) { }
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  config: AdDialogConfig;
  templateRefContext: any;
  ngOnInit() {
    this.config = this.context.config as AdDialogConfig;
    this.templateRefContext = this.config.data;
  }

  yesDialog() {
    if (this.config.onConfirmOk) {
      this.config.onConfirmOk();
    }
    this.context.close(this.context.overlayRef);
  }

  closeDialog() {
    if (this.config.onConfirmNo) {
      this.config.onConfirmNo();
    }
    this.context.close(this.context.overlayRef);
    this.onClose.emit();
  }

  ngOnDestroy(): void {
    this.context = null;
    this.config = null;
  }

}
